import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
/**
 * Please DO NOT import Functional Modules separately here.
 * If you want to add/enable new modules to the list make changes 
 * to all-baseframework-submodules.ts
 */
import { BaseFrameworkSubModules } from './all-baseframework-submodules'
import { ApiPrefixInterceptor, CacheInterceptor, ErrorHandlerInterceptor } from './core/interceptors'
import { AllowFutureOnlyValidator, CustomRequiredValidator, DiscountValidator, DiscountValidatorTravel, DobValidator, DobValidatorTraveller, FutureDateValidator, ManufacturedDateValidator, PastDateValidator, PastHundredOrFutureDateValidator, TodayOrFutureDateValidator, TravelerValidator, ValidPlateWithRegionCd } from './shared/custom-directives'


export const customValidators: any = [AllowFutureOnlyValidator, CustomRequiredValidator, DiscountValidator, DiscountValidatorTravel, DobValidator, DobValidatorTraveller, FutureDateValidator, ManufacturedDateValidator, PastDateValidator, PastHundredOrFutureDateValidator, TodayOrFutureDateValidator, TravelerValidator, ValidPlateWithRegionCd]

@NgModule({
  imports: [
    CommonModule,
    ...BaseFrameworkSubModules
  ],
  declarations: [...customValidators],
  exports: [...BaseFrameworkSubModules]
})
export class BaseframeworkModule { } 
